export default __webpack_public_path__ + "static/FavoriteVehicles-bc7a8a0ef7d7f78038ca7c3126c0d1ee.jpg";